import React, { useState, useEffect, useRef, useContext } from 'react';
import ModalChooseComponent from './ModalChooseComponent';
import Countdown from 'react-countdown';
import { transferToTheGame, withdrawNftFromGame, registration, buySlot, addToSlot, tokenDeposite, remFromSlot, claim, addRuna, remRuna, actvipspin, tokenWithdraw, buyInStorage, craft, buyMult, spin } from '../../components/Wax/Transactions';

const spinList = () => [
    {
        name: "promo",
        img: "/img/0.webp",
        tmpl: 716921
    },
    {
        name: "common",
        img: "/img/1.webp",
        tmpl: 716922
    },
    {
        name: "uncommon",
        img: "/img/2.webp",
        tmpl: 750023
    },
    {
        name: "rare",
        img: "/img/3.webp",
        tmpl: 716924
    },
    {
        name: "epic",
        img: "/img/4.webp",
        tmpl: 716925
    },
    {
        name: "legendary",
        img: "/img/5.webp",
        tmpl: 716926
    },

    {
        name: "promo",
        img: "/img/runes/0.webp",
        tmpl: 761126
    },
    {
        name: "common",
        img: "/img/runes/1.webp",
        tmpl: 749979
    },
    {
        name: "uncommon",
        img: "/img/runes/2.webp",
        tmpl: 749981
    },
    {
        name: "rare",
        img: "/img/runes/3.webp",
        tmpl: 749982
    },
    {
        name: "epic",
        img: "/img/runes/4.webp",
        tmpl: 749983
    },
    {
        name: "legendary",
        img: "/img/runes/5.webp",
        tmpl: 749984
    }
]

const chooseByName = (name) => {
    let obj;
    if (name == "promo" || name === 0) {
        obj = {
            rarity: 0,
            asset_id: 1000000000000000,
            //user	
            cons: 0.2,
            mult: 1.1,
            countdown: 3600 * 3,
            speed: 1,
            speed_up: 40,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            rarity: 0,
            //timer	
            //in_slot	
            vip: 0,
            tmpl: 716921,
            tmplRunes: 761126,
            price: 0,
            priceHist: 0,
            priceRunes: 0,
            priceRunesHist: 0,
            buySpin: 960000,
            buyRunes: 1920000
            //lastacttime	
            //boofsec	
            //inlottery
        }
    } else if (name == "promo2" || name === 6) {
        obj = {
            rarity: 0,
            asset_id: 1000000000000000,
            //user	
            cons: 0.2,
            mult: 1.1,
            countdown: 3600 * 3,
            speed: 1,
            speed_up: 40,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            rarity: 0,
            //timer	
            //in_slot	
            vip: 0,
            tmpl: 716921,
            tmplRunes: 761126,
            price: 0,
            priceHist: 0,
            priceRunes: 0,
            priceRunesHist: 0,
            buySpin: 960000,
            buyRunes: 1920000
            //lastacttime	
            //boofsec	
            //inlottery
        }
    } else if (name == "common" || name === 1) {
        obj = {
            rarity: 1,
            asset_id: 1000000000000000,
            cons: 1,
            mult: 1.1,
            countdown: 3600 * 3,
            speed: 1,
            speed_up: 40,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            vip: 0,
            tmpl: 716922,
            tmplRunes: 749979,
            price: 0,
            priceHist: 0,
            priceRunes: 0,
            priceRunesHist: 0,
            buySpin: 4800000,
            buyRunes: 9600000
        }
    } else if (name == "uncommon" || name === 2) {
        obj = {
            rarity: 2,
            asset_id: 1000000000000000,
            cons: 2,
            mult: 1.1,
            countdown: 3600 * 3,
            speed: 1,
            speed_up: 40,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            vip: 0,
            tmpl: 750023,
            tmplRunes: 749981,
            price: 0,
            priceHist: 0,
            priceRunes: 0,
            priceRunesHist: 0,
            buySpin: 9600000,
            buyRunes: 19200000
        }
    } else if (name == "rare" || name === 3) {
        obj = {
            rarity: 3,
            asset_id: 1000000000000000,
            cons: 8,
            mult: 1.1,
            countdown: 3600 * 6,
            speed: 1,
            speed_up: 20,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            vip: 0,
            tmpl: 716924,
            tmplRunes: 749982,
            price: 0,
            priceHist: 0,
            priceRunes: 0,
            priceRunesHist: 0,
            buySpin: 19200000,
            buyRunes: 38400000
        }
    } else if (name == "epic" || name === 4) {
        obj = {
            rarity: 4,
            asset_id: 1000000000000000,
            cons: 16,
            mult: 1.1,
            countdown: 3600 * 6,
            speed: 1,
            speed_up: 20,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            vip: 0,
            tmpl: 716925,
            tmplRunes: 749983,
            price: 0,
            priceHist: 0,
            priceRunes: 0,
            priceRunesHist: 0,
            buySpin: 38400000,
            buyRunes: 76800000
        }
    } else if (name == "legendary" || name === 5) {
        obj = {
            rarity: 5,
            asset_id: 1000000000000000,
            cons: 64,
            mult: 1.1,
            countdown: 3600 * 12,
            speed: 1,
            speed_up: 10,
            spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            runes: 0,
            vip: 0,
            tmpl: 716926,
            tmplRunes: 749984,
            price: 0,
            priceHist: 0,
            priceRunes: 0,
            priceRunesHist: 0,
            buySpin: 76800000,
            buyRunes: 153600000
        }
    }

    return obj;
}

const mult = [
    [0, 1.1, 1.325, 1.55, 1.775, 2],
    [0, 1.1, 1.325, 1.55, 1.775, 2],
    [0, 1.1, 1.35, 1.6, 1.85, 2.1],
    [0, 1.1, 1.375, 1.65, 1.925, 2.2],
    [0, 1.1, 1.4, 1.7, 2, 2.3],
    [0, 1.1, 1.45, 1.8, 2.15, 2.5],
    [0, 1.1, 1.325, 1.55, 1.775, 2]
];

function CalculatorComponent({ allSpinnerInGame, setSpendSpn, setGetSpn, prices, pricesHist, setAllSlotPrice, accountName, ual }) {
    const [modalChooseOpen, setModalChooseOpen] = useState(false);
    const [typeModal, setTypeModal] = useState("");
    const [indexMoldaSpin, setIndexMoldaSpin] = useState(null);
    const [localList, setlocalList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [reinv, setReinv] = useState(false);
    const [reinvAll, setReinvAll] = useState(false);
    const [allInfo, setAllInfo] = useState(false);
    const [showPrice, setShowPrice] = useState(false);
    const [refreshKey1, setRefreshKey1] = useState(0);

    const [wasChange, setWasChange] = useState(0);
    const [activeVersion, setActiveVersion] = useState(0);

    const [assetToSend, setAssetToSEnd] = useState([]);

    //const [view, setView] = useState(false);
    //const [allSpinnerInGameLocal, setAllSpinnerInGameLocal] = useState([]);
    const [view, setView] = useState(() => {
        const views = localStorage.getItem('view');
        return views ? JSON.parse(views) : false;
    });

    const [fields, setFields] = useState({
        slotPrice: 80,
        days: 0,
        userMult: 1,
        refMult: 1
    });


    const refreshAssets = (type) => {
        setRefreshKey1(prevKey => prevKey + 1);
    };

    const refreshVers = (type) => {
        setWasChange(prevKey => prevKey + 1);
    };

    const [log, setLog] = useState(`Привет ${accountName}, Стартуееем!!!\nПроверка раз в 10 сек\n-------------------------------\n`);
    const [counter, setCounter] = useState(0);
    const logRef = useRef(null);

    useEffect(() => {
        if (fields.slotPrice == 11) {
            const intervalId = setInterval(() => {

                let arreyToSend = localList.filter((item) => item.in_slot === 1 && item.timer <= Date.now() / 1000 && item.runes === 0).map((item2) => parseInt(item2.asset_id));

                const newDate = new Date().toLocaleString();
                let newLog = `${log}Запрос №: ${counter}, Текущая дата: ${newDate}\n`;

                setCounter(prevCounter => prevCounter + 1);

                if (arreyToSend && arreyToSend.length) {
                    sendSpin(arreyToSend);
                }

                setLog(newLog);
            }, 10 * 1000);
            return () => clearInterval(intervalId);
        }

    }, [fields, counter]);

    // useEffect(() => {
    //     const intervalId = setInterval(() => {
    //         const newDate = new Date().toLocaleString();
    //         const newLog = `${log}Счетчик: ${counter}, Текущая дата: ${newDate}\n`;
    //         setLog(newLog);
    //         setCounter(prevCounter => prevCounter + 1);
    //     }, 1000);

    //     return () => clearInterval(intervalId);
    // }, [log, counter]);

    useEffect(() => {
        if (logRef.current) {
            logRef.current.scrollTop = logRef.current.scrollHeight;
        }
    }, [log]);

    // const timerReboot = () => {

    //     let arreyToSend = localList.filter((item) => item.in_slot === 1 && item.timer <= Date.now() / 1000 && item.runes === 0 && !item.vip).map((item2) => parseInt(item2.asset_id));

    //     console.log("arreyToSend", arreyToSend)
    //     console.log("localList", localList)

    //     setAssetToSEnd(arreyToSend);
    // }

    const sendSpin = async (arreyToSend) => {
        try {
            console.log("type");
            const { activeUser } = ual;
            //const { accountName } = activeUser;

            const transactionPayload = spin(accountName, arreyToSend);

            console.log("transactionPayload", transactionPayload)

            const transaction = await activeUser.signTransaction(transactionPayload, {
                blocksBehind: 3,
                expireSeconds: 30,
            });

            console.log("transaction", transaction);

            const newDate = new Date().toLocaleString();
            let newLog = `${log}nft с id: ${arreyToSend}, было отправлени, Текущая дата: ${newDate}\n`;

            const updatedSpinners = localList.map(spin => {

                if (arreyToSend.includes(parseInt(spin.asset_id))) {
                    return {
                        ...spin,  // spread operator to copy all existing fields
                        timer: Math.floor(Date.now() / 1000) + spin.countdown,
                    }
                } else {
                    return spin
                }
            });

            console.log("updatedSpinners", updatedSpinners);
            setlocalList(updatedSpinners);
            setLog(newLog);

            //setAllSpinnerInGame(updatedAllSinnersInGameLocal);
        } catch (e) {
            //timerReboot();
            //sendSpin(arreyToSend);
            let newLog = `${log}Ошибка отправки: ${e}\n`;
            setLog(newLog);
            console.log(e);
        }
    }

    useEffect(() => {

        // const [wasChange, setWasChange] = useState(0);
        // const [activeVersion, setVctiveVersion] = useState(0);

        // console.log("wasChange", wasChange)
        // console.log("activeVersion", activeVersion)

        if (allSpinnerInGame && allSpinnerInGame.length && !localList.length || wasChange != activeVersion) {

            let arreyToSend = []

            const updatedList = allSpinnerInGame.filter(item => item.in_slot === 1).sort(compareRarity).map((item) => {
                let allDefInfo = chooseByName(item.rarity);

                if (item.timer <= Math.floor(Date.now() / 1000) && item.runes === 0 && !item.vip) {
                    arreyToSend.push(parseInt(item.asset_id));
                }

                if (!allInfo) {
                    return {
                        ...item,  // spread operator to copy all existing fields
                        cons: allDefInfo.cons,
                        mult: allDefInfo.mult,
                        speed: allDefInfo.speed,
                        storage: allDefInfo.storage,
                        spins: allDefInfo.spins,
                        tmpl: allDefInfo.tmpl,
                        tmplRunes: allDefInfo.tmplRunes,
                        price: allDefInfo.price,
                        priceHist: allDefInfo.priceHist,
                        priceRunes: allDefInfo.priceRunes,
                        priceRunesHist: allDefInfo.priceRunesHist,
                        buySpin: allDefInfo.buySpin,
                        buyRunes: allDefInfo.buyRunes,
                        //timer: (Date.now() + 5000) / 1000,
                    }
                } else {
                    return {
                        ...item,  // spread operator to copy all existing fields
                        cons: allDefInfo.cons,
                        mult: allDefInfo.mult,
                        speed: item.speed,
                        storage: item.storage / 10000,
                        spins: item.spins,
                        tmpl: allDefInfo.tmpl,
                        tmplRunes: allDefInfo.tmplRunes,
                        price: allDefInfo.price,
                        priceHist: allDefInfo.priceHist,
                        priceRunes: allDefInfo.priceRunes,
                        priceRunesHist: allDefInfo.priceRunesHist,
                        buySpin: allDefInfo.buySpin,
                        buyRunes: allDefInfo.buyRunes,
                        //timer: (Date.now() + 5000) / 1000,
                    }
                }


            });

            //console.log("AAAAAAA")

            setAssetToSEnd(arreyToSend);
            setlocalList(updatedList);
            setUserList(updatedList);
            setActiveVersion(wasChange);
        }
    }, [allSpinnerInGame, allInfo, assetToSend, wasChange]);

    useEffect(() => {

        if (prices && prices.length && pricesHist && pricesHist.length && showPrice //&& !listWithPrice.length
        ) {
            const updatedSpinList = localList.map(spinItem => {
                // Находим соответствующий элемент в results
                const resultItem = prices.find(result => result.template_id == spinItem.tmpl);
                const resultItemHist = pricesHist.find(result => result.template_id == spinItem.tmpl);
                const resultItemRunes = prices.find(result => result.template_id == spinItem.tmplRunes);
                const resultItemRunesHist = pricesHist.find(result => result.template_id == spinItem.tmplRunes);
                // Если в resultItem есть данные и у них есть price, извлекаем эту цену
                //const pr = resultItem ? resultItem.price : null;
                //const prHist = resultItemHist ? resultItemHist.price : null;
                // Возвращаем новый объект, добавляя информацию о цене
                return {
                    ...spinItem,
                    price: resultItem ? resultItem.price : null,
                    priceHist: resultItemHist ? resultItemHist.price : null,
                    priceRunes: resultItemRunes ? resultItemRunes.price : null,
                    priceRunesHist: resultItemRunesHist ? resultItemRunesHist.price : null
                };
            });

            console.log("updatedSpinList", updatedSpinList)
            setlocalList(updatedSpinList);
        }
    }, [showPrice, prices, pricesHist, refreshKey1]);

    const openModal = (e, type, index) => {
        if (e) {
            setModalChooseOpen(true);
            setTypeModal(type);
            setIndexMoldaSpin(index);
        } else {
            setModalChooseOpen(false);
            setTypeModal("");
            setIndexMoldaSpin(null);
        }
    }

    const addNew = (name, number) => {
        let moreOne = chooseByName(name);
        var updateLocalList = [...localList];

        if (number > 0) {
            for (let index = 0; index < number; index++) {
                updateLocalList.push(moreOne);
            }
        }

        setlocalList(updateLocalList);
        setModalChooseOpen(false);
    }

    const changeSpin = (name, index) => {
        let moreOne = chooseByName(name);
        let updatedLocalList = [...localList];

        console.log("moreOne", moreOne)

        const updatedSpinner = {
            ...updatedLocalList[index],
            //...moreOne,
            rarity: moreOne.rarity,
            asset_id: 1000000000000000,
            cons: 1,
            mult: moreOne.mult,
            countdown: moreOne.countdown,
            //speed: 1,
            speed_up: moreOne.speed_up,
            //spins: 0,
            storage: 0,
            spend: 0,
            get: 0,
            //runes: 0,
            //vip: 0,
            tmpl: moreOne.tmpl,
            tmplRunes: moreOne.tmplRunes,
            price: moreOne.price,
            priceHist: moreOne.priceHist,
            priceRunes: moreOne.priceRunes,
            priceRunesHist: moreOne.priceRunesHist,
            buySpin: moreOne.buySpin,
            buyRunes: moreOne.buyRunes,
        };
        updatedLocalList[index] = updatedSpinner;
        setlocalList(updatedLocalList);
        setModalChooseOpen(false);
        // } else {
        //     const updatedSpinner = {
        //         ...updatedLocalList[index],
        //         runes: 0
        //     };
        //     updatedLocalList[index] = updatedSpinner;
        // }
        //setlocalList(updatedLocalList);
    }



    const remSpin = (index) => {
        let updatedLocalList = [...localList];
        updatedLocalList.splice(index, 1);

        setlocalList(updatedLocalList);
        setModalChooseOpen(false);

    }


    const changeSpeed = (index, num) => {
        let updatedLocalList = [...localList];

        const updatedSpinner = {
            ...updatedLocalList[index],
            speed: num,
            speedWasChange: true,
        };
        updatedLocalList[index] = updatedSpinner;
        setlocalList(updatedLocalList);
    }

    const views = (e) => {
        setView(e);
        localStorage.setItem('view', e.toString());
    }

    const clearall = (e) => {
        setlocalList([]);
    }

    const reinvestCheck = (e) => {
        setReinv(!e);
    }
    const reinvestAllCheck = (e) => {
        setReinvAll(!e);
    }
    const getAllInfoFormGame = (e) => {
        if (!e) {
            setReinv(false)
            setReinvAll(false)
        }
        setAllInfo(!e);
        refreshVers();
    }
    const showHidePrice = (e) => {
        setShowPrice(!e);
    }

    const addRuna = (e, index) => {
        let updatedLocalList = [...localList];
        if (e) {
            const updatedSpinner = {
                ...updatedLocalList[index],
                runes: 1111111
            };
            updatedLocalList[index] = updatedSpinner;
        } else {
            const updatedSpinner = {
                ...updatedLocalList[index],
                runes: 0
            };
            updatedLocalList[index] = updatedSpinner;
        }
        setlocalList(updatedLocalList);
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFields(prevFields => ({
            ...prevFields,
            [name]: value
        }));
    };

    const recalculate = (spin) => {
        const cons = spin.cons;
        const count = spin.countdown;
        const speedup = spin.speed_up;
        const rar = spin.rarity;
        const hasRune = spin.runes ? true : false;

        //const prem = getActiveValue(".btn_prem .btn__spin.active");
        const profileMultiplier = fields.userMult;
        const referralMultiplier = fields.refMult;
        const period = fields.days;

        //let sumforstart = spin.cons;

        // console.log("Set:", set);
        // console.log("cons:", cons);
        // console.log("count:", count);
        // console.log("rar:", rar);
        // console.log("Has Rune:", hasRune);
        // console.log("prem:", prem);
        // console.log("Profile Multiplier:", profileMultiplier);
        // console.log("Referral Multiplier:", referralMultiplier);
        // console.log("Period:", period);
        // console.log("speedup:", speedup);

        var spinSpeedPaymentLocal = 1;
        let new_score = 0;
        let wasPay = 0;

        let allSumSpinsPaymentLocal = 0;
        let periodLocal = period * 24 * 60 * 60;
        //console.log("periodLocal", periodLocal)

        if (allInfo) {
            spinSpeedPaymentLocal = spin.speed;
            allSumSpinsPaymentLocal = spin.spins;
            new_score = spin.storage;
        }

        if (spin && spin.speedWasChange !== undefined && spin.speedWasChange) {
            spinSpeedPaymentLocal = spin.speed;
        }

        //console.log("spinSpeedPaymentLocal", spinSpeedPaymentLocal);
        //console.log("allSumSpinsPaymentLocal", allSumSpinsPaymentLocal);

        while (periodLocal > 0) {
            let sum_bonus = 0;

            // if (reinvAll) {
            //     sumforstart -= cons;
            // }

            //if (prem == "1") {
            sum_bonus = parseFloat(profileMultiplier) + parseFloat(referralMultiplier) - 2;
            if (spinSpeedPaymentLocal == 1) {
                sum_bonus = 0;
            } else if (spinSpeedPaymentLocal == 2) {
                sum_bonus = sum_bonus * 0.25;
            } else if (spinSpeedPaymentLocal == 3) {
                sum_bonus = sum_bonus * 0.5;
            } else if (spinSpeedPaymentLocal == 4) {
                sum_bonus = sum_bonus * 0.75;
            } else if (spinSpeedPaymentLocal == 5) {
                sum_bonus = sum_bonus;
            }
            //console.log("sum_bonus", sum_bonus)
            //}
            //console.log("sum_bonus", sum_bonus)
            //console.log("parseFloat(sum_bonus)", parseFloat(sum_bonus));
            if (hasRune) {
                new_score += parseFloat(cons) * (mult[rar][spinSpeedPaymentLocal] + sum_bonus);
                wasPay += 0;
            } else {
                new_score += (parseFloat(cons) * (mult[rar][spinSpeedPaymentLocal] + sum_bonus)) - parseFloat(cons);

                if (!reinvAll) {
                    wasPay += cons;
                } else {
                    wasPay = cons;
                }


            }

            //console.log("new_score", new_score);


            if (!reinv && !reinvAll || reinv && !hasRune) {
                if (allSumSpinsPaymentLocal + 1 == parseInt(speedup)) {
                    allSumSpinsPaymentLocal = 0;
                    if (spinSpeedPaymentLocal < 5) {
                        spinSpeedPaymentLocal++;
                    }
                } else {
                    allSumSpinsPaymentLocal++;
                }
            } else if (reinvAll) {
                let spinsnow = parseInt((wasPay + new_score) / cons);
                let speednow = parseInt(spinsnow / speedup);

                if (spinsnow % speedup) {

                }

                // console.log("spinsnow % speedup", spinsnow % speedup);
                // console.log("speednow", speednow);
                // console.log("spinsnow", spinsnow);
                // console.log("speednow < 5", speednow < 5);

                allSumSpinsPaymentLocal = spinsnow ? spinsnow % speedup : 0;
                spinSpeedPaymentLocal = speednow < 5 ? speednow + 1 : 5;
            }
            periodLocal -= count;

            // if (reinvAll) {
            //     sumforstart += cons + new_score;
            //     //new_score += new_score;
            // }

            //console.log("sumforstart", sumforstart);
            //console.log("periodLocal", periodLocal);
        }


        //console.log("new_score", new_score);
        // divResult.innerHTML = "+" + new_score.toFixed(2);
        // divWax.innerHTML = "+" + (new_score * datas.last_price).toFixed(2);
        // divUsdt.innerHTML = "+" + (new_score * datas.last_price * datas2.last_price).toFixed(2);

        //console.log("wasPay", wasPay);
        return {
            storage: wasPay + new_score,
            get: reinvAll ? new_score : new_score,
            spend: reinvAll && !hasRune ? cons : wasPay,
            speed: spinSpeedPaymentLocal,
            spins: allSumSpinsPaymentLocal,
            runesReinv: reinv && hasRune ? new_score : 0
        };
    }

    // Function to calculate total earnings from all users
    const calculateTotalEarnings = () => {

        //let spinners = [...localList];
        let get = 0;
        let spend = 0;
        let runesReinv = 0;
        let reinSpnStart = 0;

        let sumForStart = 0;
        let slotPrice = 0;
        //let oneDaySpendAllSpin = 0;
        //let oneDaySpendSpn = 0;
        //let manyActiveSpins = 0;
        localList.map(spin => {
            sumForStart += spin.cons;
            reinSpnStart += spin.storage;
            if (spin.rarity !== 0) {
                slotPrice += fields.slotPrice;
            }
            // if (reinv && allInfo && spin.runes === 0) {
            //     oneDaySpendAllSpin += (86400 / spin.countdown) // сколько раз нужно крутить
            //     oneDaySpendSpn += spin.cons * (86400 / spin.countdown); // сколько спн потратится
            //     manyActiveSpins += 1;
            //     console.log("oneDaySpendSpn", oneDaySpendSpn)
            //     console.log("(spin.countdown)", spin.countdown)
            //     console.log("(86400 / spin.countdown)", (86400 / spin.countdown))
            // }
        });

        // console.log("reinSpnStart", reinSpnStart)
        // console.log("oneDaySpendAllSpin", oneDaySpendAllSpin)
        // console.log("oneDaySpendSpn", oneDaySpendSpn)
        // console.log("oneDaySpendSpn", oneDaySpendSpn * fields.days);
        // console.log("spend one hour", oneDaySpendSpn / 24)
        // let spendInOneHour = oneDaySpendSpn / 24;




        //console.log("sumForStart", sumForStart);

        if (allInfo) {
            const updatedSpinners = userList.map(spin => {

                const finance = recalculate(spin);
                get += finance.get;
                spend += finance.spend;
                runesReinv += finance.runesReinv;

                //console.log("finance", finance)

                return {
                    ...spin,  // spread operator to copy all existing fields
                    storage: finance.storage,
                    get: finance.get,
                    spend: finance.spend,
                    speed: finance.speed,
                    spins: finance.spins,
                }
            });

            //console.log("updatedSpinners", updatedSpinners);
            setlocalList(updatedSpinners);
        } else {
            const updatedSpinners = localList.map(spin => {

                const finance = recalculate(spin);
                get += finance.get;
                spend += finance.spend;
                runesReinv += finance.runesReinv;

                //console.log("finance", finance)

                return {
                    ...spin,  // spread operator to copy all existing fields
                    storage: finance.storage,
                    get: finance.get,
                    spend: finance.spend,
                    speed: finance.speed,
                    spins: finance.spins,
                }
            });

            //console.log("updatedSpinners", updatedSpinners);
            setlocalList(updatedSpinners);
        }

        console.log("slotPrice", slotPrice)
        setAllSlotPrice(slotPrice);
        return { get, spend, runesReinv, sumForStart: sumForStart };
    }

    // useEffect(() => {
    //     const totalEarnings = calculateTotalEarnings();
    //     console.log('Total Earnings:', totalEarnings);
    //     setSpendSpn(totalEarnings.spend);
    //     setGetSpn(totalEarnings.get);

    // }, [localList]);

    const filternow = (e) => {
        refreshAssets();
        const totalEarnings = calculateTotalEarnings();

        setSpendSpn(reinv ? totalEarnings.spend - totalEarnings.runesReinv : reinvAll ? totalEarnings.sumForStart : totalEarnings.spend);
        setGetSpn(totalEarnings.get);

        //console.log('Total Earnings:', totalEarnings);
    }

    function compareRarity(a, b) {
        let res = b.rarity - a.rarity;

        if (a.rarity == 6 && b.rarity == 6) {
            res = 0;
        } else if (a.rarity == 6) {
            res = b.rarity - 0;
        } else if (b.rarity == 6) {
            res = 0 - a.rarity;
        }
        return res;
    }



    return (
        <>
            <div className="filter">
                <div className="left-part-filter">
                    <button className={`view ${view ? "" : "active"}`} onClick={() => views(false)}>
                        |||||| FULL
                    </button>
                    <button className={`view ${view ? "active" : ""}`} onClick={() => views(true)}>
                        || MINI
                    </button>
                </div>
                <div className="right-part-filter">
                    <button className={`view`} onClick={() => clearall(true)}>
                        CLEAR ALL
                    </button>
                </div>

                <div className="filter-inputs">
                    <div className="filter-input">
                        <div className="one-filt-inp">
                            <div className="one-filt-name">
                                slot price (WAX):
                            </div>
                            <input
                                type="number"
                                name={`slotPrice`}
                                value={fields[`slotPrice`]}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="filter-input">
                        <div className="one-filt-inp">
                            <div className="one-filt-name">
                                work days:
                            </div>
                            <input
                                type="number"
                                name={`days`}
                                value={fields[`days`]}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="filter-input">
                        <div className="one-filt-inp">
                            <div className="one-filt-name">
                                user mult:
                            </div>
                            <input
                                type="number"
                                name={`userMult`}
                                value={fields[`userMult`]}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="filter-input">
                        <div className="one-filt-inp">
                            <div className="one-filt-name">
                                ref mult:
                            </div>
                            <input
                                type="number"
                                name={`refMult`}
                                value={fields[`refMult`]}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {!allInfo ?
                        <div className="filter-input">
                            <div className="one-filt-inp">
                                <div className="one-filt-name">
                                    reinvest runes:
                                </div>
                                <div className={`check-cast tooltip ${reinv ? "active" : ""}`} onClick={() => reinvestCheck(reinv)}>
                                    <div className="tooltip-body">
                                        you use spinneys with a rune as a reinvestment spn to scroll other spinneys
                                    </div>
                                </div>
                            </div>
                        </div>
                        : <div className="filter-input disabled">
                            <div className="one-filt-inp">
                                <div className="one-filt-name">
                                    reinvest runes:
                                </div>
                                <div className={`check-cast tooltip`} >
                                    <div className="tooltip-body">
                                        currently does not work in the mode when the "get real info from game" checkbox is enabled
                                    </div>
                                </div>
                            </div>
                        </div>}
                    {!allInfo ?
                        <div className="filter-input">
                            <div className="one-filt-inp">
                                <div className="one-filt-name">
                                    reinvest every spin:
                                </div>
                                <div className={`check-cast tooltip ${reinvAll ? "active" : ""}`} onClick={() => reinvestAllCheck(reinvAll)}>
                                    <div className="tooltip-body">
                                        shows how much you can earn without investing money to spin the spinney. Only the first spin on which you need to spend spn is taken into account.
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="filter-input disabled">
                            <div className="one-filt-inp">
                                <div className="one-filt-name">
                                    reinvest every spin:
                                </div>
                                <div className={`check-cast tooltip`} >
                                    <div className="tooltip-body">
                                        currently does not work in the mode when the "get real info from game" checkbox is enabled
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {allSpinnerInGame && allSpinnerInGame.length ?
                        <div className="filter-input">
                            <div className="one-filt-inp">
                                <div className="one-filt-name">
                                    get real info from game:
                                </div>
                                <div className={`check-cast tooltip ${allInfo ? "active" : ""}`} onClick={() => getAllInfoFormGame(allInfo)}>
                                    <div className="tooltip-body">
                                        get all spinney values from the game at that moment
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null}


                    <div className="filter-input">
                        <div className="one-filt-inp">
                            <div className="one-filt-name">
                                show all price:
                            </div>
                            <div className={`check-cast tooltip ${showPrice ? "active" : ""}`} onClick={() => showHidePrice(showPrice)}>
                                <div className="tooltip-body">
                                    shows price from atomic hub
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="filter-input">
                        <div className="one-filt-inp">
                            <button onClick={() => filternow()}>
                                filter now
                            </button>
                        </div>
                    </div>
                </div>



            </div>

            {fields.slotPrice == 11 ?
                <div className="console">
                    <div className="console-tit">
                        console autosend:
                    </div>
                    <div className="console-body">
                        <textarea ref={logRef} value={log} readOnly name="" id="" cols="30" rows="10"></textarea>
                    </div>
                </div>
                : null
            }

            <div className={`all-spin ${view ? "short" : "full"}`}>

                {localList && localList.length ?

                    localList.map((item, index) => {
                        return (
                            <div className={`one-spin ${showPrice ? "show-price" : ""}`} key={index}>
                                {showPrice ?
                                    <div className="slotPrice">
                                        price slot: {item.rarity !== 0 ? fields.slotPrice : 0} WAX
                                    </div>
                                    : null
                                }
                                <div className='remove-spiner' onClick={() => remSpin(index)}>
                                    remove
                                </div>
                                <div className='change-spiner' onClick={() => openModal(true, "change", index)}>
                                    change
                                </div>

                                <div className="one-spin-img">
                                    <span>
                                        <img src={`/img/${item.rarity}.webp`} alt="" />
                                        {showPrice ?
                                            <div className="spinPrice">
                                                price spinney: {item.price / 100000000 || item.priceHist / 100000000} WAX
                                            </div>
                                            : null
                                        }
                                    </span>

                                </div>

                                <div className="one-spin-runes">
                                    {item.runes !== 0 ?
                                        <span className="rem-runes" onClick={() => addRuna(false, index)}>
                                            <img src={`/img/runes/${item.rarity}.webp`} alt="" />
                                            <i></i>
                                        </span>
                                        :

                                        !allInfo ?
                                            <span className="add-runes" onClick={() => addRuna(true, index)}>
                                                <i></i>
                                            </span>
                                            : <span className="add-runes tooltip">
                                                <div className="tooltip-body">
                                                    adding a rune only works if you have the "get real info from game" checkbox turned off
                                                </div>
                                            </span>
                                    }

                                    {showPrice ?
                                        <div className="runesPrice">
                                            price runes: {item.priceRunes / 100000000 || item.priceRunesHist / 100000000} WAX
                                        </div>
                                        : null
                                    }

                                </div>

                                <div className="one-spin-timer">
                                    <div className="one-spin-names">
                                        vip function demo:
                                    </div>
                                    <Countdown
                                        daysInHours
                                        //date={item.timer * 1000}
                                        date={item.timer * 1000}
                                        key={item.timer}
                                    // onComplete={(e) => {
                                    //     timerReboot()
                                    // }}
                                    />
                                </div>

                                <div className={`one-spin-rar rar-${"1"}`}>
                                    <div className="one-spin-names">
                                        asset id:
                                    </div>
                                    {item.asset_id}
                                </div>
                                <div className="one-spin-speed">
                                    <div className="one-spin-names">
                                        speed:
                                    </div>
                                    <ul>
                                        <li onClick={() => { changeSpeed(index, 1) }} className={item.speed > 0 ? "active" : ""}>1</li>
                                        <li onClick={() => { changeSpeed(index, 2) }} className={item.speed > 1 ? "active" : ""}>2</li>
                                        <li onClick={() => { changeSpeed(index, 3) }} className={item.speed > 2 ? "active" : ""}>3</li>
                                        <li onClick={() => { changeSpeed(index, 4) }} className={item.speed > 3 ? "active" : ""}>4</li>
                                        <li onClick={() => { changeSpeed(index, 5) }} className={item.speed > 4 ? "active" : ""}>5</li>
                                    </ul>
                                </div>
                                <div className="one-spin-spins">
                                    <div className="one-spin-names">
                                        spins:
                                    </div>
                                    <div className="prog-spins"></div>
                                    {item.speed >= 5 ?
                                        "MAX" : item.spins}/{item.speed_up}
                                </div>
                                <div className="one-spin-score">
                                    <div className="one-spin-names">
                                        storage:
                                    </div>
                                    {item.storage ? (item.storage).toFixed(4) : 0} SPN
                                </div>
                                <div className="one-spin-get">
                                    <div className="one-spin-names">
                                        get:
                                    </div>
                                    {item.get ? (item.get).toFixed(4) : 0} SPN
                                </div>
                                <div className="one-spin-spend">
                                    <div className="one-spin-names">
                                        spend:
                                    </div>
                                    {item.spend ? (item.spend).toFixed(4) : 0} SPN
                                </div>
                                <div className="one-spin-detal">
                                    <div className="one-spin-names">
                                        info:
                                    </div>
                                    <div className="one-spin-cons">
                                        <span>
                                            consume: {item.cons}
                                        </span>
                                    </div>
                                    <div className="one-spin-cons">
                                        <span>
                                            mult:
                                            {mult[item.rarity][item.speed]}
                                        </span>
                                    </div>
                                </div>

                                {Math.floor(item.storage / 25) ||
                                    Math.floor(item.storage / (item.buySpin / 10000)) ||
                                    Math.floor(item.storage / (item.buyRunes / 10000)) ?
                                    <div className="one-spin-can-buy">
                                        <div className="one-spin-names">
                                            you can buy:
                                        </div>
                                        {Math.floor(item.storage / 25) ?
                                            <div className="buy-item ticket">
                                                <span>{Math.floor(item.storage / 25)}</span> tickets
                                            </div>
                                            : null
                                        }

                                        {Math.floor(item.storage / (item.buySpin / 10000)) ?
                                            <div className={`buy-item spinney rar-${item.rarity}`}>
                                                <span>{Math.floor(item.storage / (item.buySpin / 10000))}</span> spinney
                                            </div>
                                            : null
                                        }

                                        {Math.floor(item.storage / (item.buyRunes / 10000)) ?
                                            <div className={`buy-item runes rar-${item.rarity}`}>
                                                <span>{Math.floor(item.storage / (item.buyRunes / 10000))}</span> runes
                                            </div>
                                            : null
                                        }
                                    </div>
                                    : null}
                            </div>
                        )
                    })

                    : null}

                <div className="add-new-spin">
                    <span onClick={() => openModal(true, "new")}></span>
                </div>

                {modalChooseOpen ? <ModalChooseComponent openModal={openModal} typeModal={typeModal} addNew={addNew} changeSpin={changeSpin} remSpin={remSpin} indexMoldaSpin={indexMoldaSpin} /> : null}
            </div>
        </>
    );
}

export default CalculatorComponent;
